import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let RadioGroupComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.radios = new Map();
    this.currentFocused = -1;
  }
  get radioElements() {
    return Array.from(this.radios.values());
  }
  register(e) {
    const radio = e.detail[0];
    this.radios.set(radio.value, radio);
    radio.checked = this.value === radio.value;
  }
  valueChanged(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.select(this.value);
    }
  }
  change(e) {
    const value = e.detail[0];
    this.select(value);
    return value;
  }
  select(value) {
    this.radios.forEach((el) => {
      el.checked = el.value === value;
    });
  }
  setFocused(target) {
    this.currentFocused = this.radioElements.findIndex((radio) => {
      return radio === target;
    });
  }
  focusCurrent({ target }) {
    if (target) {
      this.setFocused(target);
    }
  }
  moveFocus(amount, event) {
    if (this.currentFocused === -1) {
      return;
    }
    let index = this.currentFocused + amount;
    const items = this.radioElements;
    if (!items.length) {
      return;
    }
    if (index < 0) {
      index = items.length - 1;
    }
    if (index >= items.length) {
      index = 0;
    }
    event.preventDefault();
    items.forEach((el, i) => {
      el.focused = i === index;
    });
  }
};
__decorateClass([
  Prop(String)
], RadioGroupComponent.prototype, "selected", 2);
__decorateClass([
  Prop(Boolean)
], RadioGroupComponent.prototype, "space", 2);
__decorateClass([
  Prop(Boolean)
], RadioGroupComponent.prototype, "left", 2);
__decorateClass([
  Prop(Boolean)
], RadioGroupComponent.prototype, "inline", 2);
__decorateClass([
  Prop(Boolean)
], RadioGroupComponent.prototype, "inlineNowrap", 2);
__decorateClass([
  Prop(Boolean)
], RadioGroupComponent.prototype, "column", 2);
__decorateClass([
  Prop(String)
], RadioGroupComponent.prototype, "value", 2);
__decorateClass([
  Prop(Boolean)
], RadioGroupComponent.prototype, "right", 2);
__decorateClass([
  Watch("value", { immediate: true })
], RadioGroupComponent.prototype, "valueChanged", 1);
__decorateClass([
  Emit("changed")
], RadioGroupComponent.prototype, "change", 1);
RadioGroupComponent = __decorateClass([
  Component({
    name: "ui-radio-group"
  })
], RadioGroupComponent);

export default RadioGroupComponent;
